import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';

import { formatMoney } from '../../../../../../lib/functions/utils';
import { ResellSuggestedDocument } from '../../../../../../pages/Finance/Components/Funds/FactoringFundReSell/components/NewMultiResell/types';

const ResellAmountDetail = ({
  resell,
}: {
  resell: ResellSuggestedDocument;
}) => {
  const mainData: [string, string][] = [
    ['Anticipo', `${resell.advance} %`],
    ['Monto total', formatMoney(resell.amount)],
    ['Monto neto', formatMoney(resell.netAmount)],
  ];

  const conciliationData: [string, string][] = [
    ['Conciliado venta', formatMoney(resell.documentAmountConciliated)],
    ['Conciliado mora', formatMoney(resell.arrearAmountConciliated)],
    ['Conciliado total', formatMoney(resell.netAmountConciliated)],
  ];

  const balanceData: [string, string][] = [
    ['Saldo documento', formatMoney(resell.documentAmountRemaining)],
    ['Saldo mora', formatMoney(resell.arrearAmountRemaining)],
    ['Saldo total restante', formatMoney(resell.netAmountRemaining)],
  ];

  const renderSection = (
    title: string,
    data: [string, string][],
    isTotal: boolean = false,
  ) => (
    <>
      <TableRow style={{ backgroundColor: '#f5f5f5' }}>
        <TableCell
          colSpan={2}
          style={{ fontWeight: 'bold', textAlign: 'center' }}
        >
          {title}
        </TableCell>
      </TableRow>
      {data.map((row) => (
        <TableRow key={row[0]} style={{ backgroundColor: 'white' }}>
          <TableCell
            style={{ fontWeight: 'bold', paddingLeft: isTotal ? 20 : 10 }}
          >
            {row[0]}
          </TableCell>
          <TableCell align="right">{row[1]}</TableCell>
        </TableRow>
      ))}
    </>
  );

  const renderConciliationSection = () => {
    return (
      <>
        <TableRow style={{ backgroundColor: '#f5f5f5' }}>
          <TableCell
            colSpan={2}
            style={{ fontWeight: 'bold', textAlign: 'center' }}
          >
            Conciliaciones
          </TableCell>
        </TableRow>
        {conciliationData.map((row) => (
          <TableRow key={row[0]} style={{ backgroundColor: 'white' }}>
            <TableCell style={{ fontWeight: 'bold', paddingLeft: 10 }}>
              {row[0]}
            </TableCell>
            <TableCell align="right">{row[1]}</TableCell>
          </TableRow>
        ))}
      </>
    );
  };

  return (
    <div style={{ padding: 10, maxHeight: '300px', overflow: 'auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', paddingBottom: 10 }}>
        <Typography variant="body1" fontWeight="bold">
          Detalles de la venta
        </Typography>
      </div>
      <Table size="small" style={{ border: '1px solid #e0e0e0' }}>
        <TableBody>
          {renderSection('Información de la venta', mainData)}
          {renderConciliationSection()}
          {renderSection('Saldos', balanceData, true)}
        </TableBody>
      </Table>
    </div>
  );
};

export default ResellAmountDetail;
